import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GenericService } from "src/app/commons/generic.service";
import { EnderecoResponse } from "src/app/responses/endereco-response";

@Injectable()
export class ConsultaCepService extends GenericService {
  private readonly END_POINT_API = "api/consultaCep/"
  
  constructor(http: HttpClient) {
    super(http);
  }

  public consultaCep(cep: string): Observable<EnderecoResponse>{
    return this.getMethod(this.END_POINT_API, {cep});
  }
}
